import React from 'react';
import { SFooter } from '../../styles/components/Footer';

// import { Container } from './styles';

const Footer: React.FC = () => {

const date = new Date().getFullYear();

  return (
      <SFooter>
          <p>
            © {date} Todos os direitos reservados
          </p>
      </SFooter>
  );
}

export default Footer;